<div class="col-panel-wrapper">
  <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
       [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
      <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
    </div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column of tableColumns">
        <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id, $event.checked)" [color]="'primary'">
          {{column.name}}
        </mat-checkbox>
      </div>
    </div>
  </div>

<cdk-virtual-scroll-viewport #viewportGestion id="viewportGestion" item [appendOnly]="false" [tvsItemSize]="24"
  [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
  
  <table cdk-table [dataSource]="companiaData" matSort (matSortChange)="sortData($event)" class="table-striped tableStyle">
    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
    <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
      [ngClass]="{'selected': row === filaSeleccionada}"></tr>
    <ng-container *ngFor="let tablecol of tableColumns">
      <ng-container [cdkColumnDef]="tablecol.id">
        <th cdk-header-cell *cdkHeaderCellDef mat-sort-header [style.width.px]="getHeaderWidth(tablecol.id)" class="sticky-header">
          {{tablecol.name}}
        </th>
        <td cdk-cell *cdkCellDef="let item" [ngClass]="{
          'salida': item[tablecol.id] === 'SALIDA',
          'entrada': item[tablecol.id] === 'ENTRADA',
          'numero-positivo': item[tablecol.id] > 0,
          'numero-negativo': item[tablecol.id] < 0
        }" [style.width.px]="getCellWidth(tablecol.id)" class="overflow-cell">
          <ng-container *ngIf="tablecol.isString && tablecol.id !== 'nombre'">
            {{item[tablecol.id]}}
          </ng-container>
          <a *ngIf="tablecol.id === 'nombre'" class="activo-link" [href]="urlMercadoActivo(item)" target="_blank" (click)="$event.stopPropagation()">{{item.nombre}} <mat-icon>open_in_new</mat-icon></a>
          <ng-container *ngIf="tablecol.isDate">
            {{ item[tablecol.id] ? (item[tablecol.id] | date: 'dd-MM-yyyy') : '-' }}
          </ng-container>
          <ng-container *ngIf="tablecol.isNumber && tablecol.id!=='volume' && tablecol.id!=='dias' && tablecol.id!=='variacion'">
            {{ item[tablecol.id] === -1 ? '-' : (item[tablecol.id] | number:'1.0-0') }}
          </ng-container>
          <ng-container *ngIf="tablecol.isNumber && tablecol.id==='dias'">
            {{ item[tablecol.id] === -1 ? '-' : (item[tablecol.id] | number:'1.0-0') }}
          </ng-container>
          <ng-container *ngIf="tablecol.id==='variacion'">
            {{ item.variacion == null ? '-' : (item.variacion | number:'1.2-2') + '%' }}
          </ng-container>
          <ng-container *ngIf="tablecol.isNumber && tablecol.id==='volume'">
            {{ item[tablecol.id] | numberSuffix }}
          </ng-container>

        </td>
      </ng-container>
    </ng-container>
  </table>
</cdk-virtual-scroll-viewport>
</div>
<div class="spinner-container" *ngIf="loadCompania">
  <mat-spinner diameter="100"></mat-spinner>
</div>
<div class="row mt-2">
  <app-tabla-volatilidad [isCompania]="true">

  </app-tabla-volatilidad>
</div>